module.exports = __webpack_public_path__ + "static/media/Back_arrow.93a7e15e.svg";